/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  (function cartPageSmartCart() {
    if (!document.body.classList.contains('template-cart')) return;

    function unbind() {
      const smartCart = window.Rebuy && window.Rebuy.SmartCart;

      if (!smartCart || typeof smartCart.unbindEvents !== 'function') return;

      smartCart.unbindEvents();
    }

    let attempts = 0;
    const poll = setInterval(() => {
      attempts += 1;
      unbind();

      if (attempts >= 60) clearInterval(poll);
    }, 250);

    document.addEventListener('rebuy:cart.change', unbind);
    document.addEventListener('rebuy:cart.ready', unbind);
  })();



  (function smartCartCheckoutToCartPage() {
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest && event.target.closest('.rebuy-cart__checkout-button');

        if (!button) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = window.theme.routes.cart_url;
      },
      true
    );
  })();



  (function cartPageItemCount() {
    document.addEventListener('theme:cart:added', () => {
      if (!document.querySelector('.cart-page-header [data-cart-items-qty]')) return;

      fetch(`${window.theme.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const count = document.querySelector('.cart-page-header [data-cart-items-qty]');
          const template = cart.item_count === 1 ? window.theme.strings.cart_items_one : window.theme.strings.cart_items_many;

          if (count) count.textContent = template.replace('{{ count }}', cart.item_count);
        })
        .catch(() => {});
    });
  })();



  (function cartPromoCode() {
    function apply(input) {
      const code = input.value.trim();

      if (!code) return;

      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
    }

    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-cart-promo-apply]');
      const input = button && button.parentElement.querySelector('[data-cart-promo-input]');

      if (!input) return;

      apply(input);
    });

    document.addEventListener('keydown', (event) => {
      const input = event.target.closest && event.target.closest('[data-cart-promo-input]');

      if (!input || event.key !== 'Enter') return;

      event.preventDefault();
      apply(input);
    });
  })();



  (function sideCartLayout() {
    const summaryTemplate = document.getElementById('SideCartSummary');
    const trustTemplate = document.getElementById('SideCartTrust');
    const stringsElement = document.getElementById('SideCartStrings');

    if (!summaryTemplate || !trustTemplate || !stringsElement) return;

    const strings = JSON.parse(stringsElement.textContent);

    function money(cents) {
      return cents === 0 ? strings.free : window.theme.formatMoney(cents, window.theme.moneyFormat);
    }

    function row(label, value, valueClass) {
      const element = document.createElement('div');
      const labelElement = document.createElement('span');
      const valueElement = document.createElement('span');

      element.className = 'cart-summary__row';
      labelElement.className = 'cart-summary__label';
      labelElement.textContent = label;
      valueElement.textContent = value;

      if (valueClass) valueElement.className = valueClass;

      element.append(labelElement, valueElement);

      return element;
    }

    function updateTitle(root, cart) {
      const title = root.querySelector('.rebuy-cart__flyout-title');

      if (!title || title.dataset.count === String(cart.item_count)) return;

      const template = cart.item_count === 1 ? window.theme.strings.cart_items_one : window.theme.strings.cart_items_many;
      const count = document.createElement('span');

      count.className = 'cart-page-header__count';
      count.textContent = ` (${template.replace('{{ count }}', cart.item_count)})`;
      title.dataset.count = String(cart.item_count);
      title.textContent = strings.title;
      title.append(count);
    }

    function updateSummary(footer, cart) {
      const rows = footer.querySelector('[data-side-cart-rows]');
      const total = footer.querySelector('[data-side-cart-total]');
      const discounts = cart.cart_level_discount_applications || [];
      const signature = JSON.stringify([cart.original_total_price, cart.total_price, discounts.map((discount) => [discount.title, discount.total_allocated_amount])]);

      footer.classList.toggle('side-cart-footer--empty', cart.item_count === 0);

      if (!rows || rows.dataset.signature === signature) return;

      const shippingIsFree = !strings.freeShippingLimit || cart.total_price >= strings.freeShippingLimit;
      const fragment = document.createDocumentFragment();

      fragment.append(row(strings.subtotal, money(cart.original_total_price)));

      discounts.forEach((discount) => {
        fragment.append(row(discount.title, `-${window.theme.formatMoney(discount.total_allocated_amount, window.theme.moneyFormat)}`, 'cart-summary__value--success'));
      });

      fragment.append(
        row(strings.shipping, shippingIsFree ? strings.shippingFree : strings.calculatedAtCheckout, shippingIsFree ? 'cart-summary__value--success' : 'cart-summary__value--faint'),
        row(strings.estimatedTax, strings.calculatedAtCheckout, 'cart-summary__value--faint')
      );

      rows.replaceChildren(fragment);
      rows.dataset.signature = signature;
      total.textContent = money(cart.total_price);
    }

    function sync() {
      const root = document.getElementById('rebuy-cart');
      const footer = root && root.querySelector('.rebuy-cart__flyout-footer');
      const actions = footer && footer.querySelector('.rebuy-cart__flyout-actions');
      const cart = window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.cart;

      if (!actions || !cart) return;

      if (!footer.querySelector('[data-side-cart-summary]')) actions.before(summaryTemplate.content.cloneNode(true));
      if (!footer.querySelector('[data-side-cart-trust]')) actions.after(trustTemplate.content.cloneNode(true));

      updateTitle(root, cart);
      updateSummary(footer, cart);
    }

    let timer = null;

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(sync, 30);
    }

    const observer = new MutationObserver(() => {
      const root = document.getElementById('rebuy-cart');

      if (!root) return;

      observer.disconnect();
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
      schedule();
    });

    observer.observe(document.body, { childList: true });

    document.addEventListener('rebuy:cart.change', schedule);
    document.addEventListener('rebuy:smartcart.show', schedule);

    if (document.getElementById('rebuy-cart')) {
      observer.disconnect();
      new MutationObserver(schedule).observe(document.getElementById('rebuy-cart'), { childList: true, subtree: true, characterData: true });
      schedule();
    }
  })();



  /**
  *   Rebuy: Cart Change
  *   reference: https://developers.rebuyengine.com/reference/cart-methods
  */
  document.addEventListener('rebuy:cart.change', function (event) {
    /**
    *   Update Pillow Quantity
    *   Sets the pillow quantity when items in the cart have changed
    */
    function updateFreePillowsQuantity() {
      const Cart = window.Rebuy.Cart;
      let productIds = [7007705399339, 4472568447019, 1811177930795, 6551185293355];
      let { cart } = event.detail.cart;

      if (!cart) return;

      let eligibleProducts = cart.items.filter((item) => productIds.includes(item.product_id));

      eligibleProducts.forEach(product => {
        let matchingPillow = cart.items.find((item) => Number(item.properties.mattress) == product.variant_id);
        let updatedQuantity = product.quantity * 2;

        if (!matchingPillow) return;

        if (matchingPillow.quantity !== updatedQuantity) {
          Cart.changeItem({ id: matchingPillow.key, quantity: updatedQuantity });
        }
      });
    }

    /**
    * Update Cart Count
    * Matches the headter cart quantity with rebuy cart quantity
    */
    function updateCartCount(event) {
      const cartCountElement = document.querySelector('.cart-item-count');
      let itemCount = event?.detail?.cart?.cart?.item_count;

      if (!cartCountElement || !itemCount) return;

      cartCountElement.innerHTML = `(${itemCount})`;
    }

    updateFreePillowsQuantity();
    updateCartCount();
  });



  /**
  *   Rebuy: Cart Page Refresh
  *
  *   The cross-sell widget adds to the cart over AJAX. The Smart Cart re-rendered
  *   itself on add, but the cart page does not, so a newly added line item would
  *   not appear until the next page load.
  *
  *   reference: https://developers.rebuyengine.com/reference/cart-event-listeners
  */
  document.addEventListener('rebuy:cart.add', function () {
    if (!document.body.classList.contains('template-cart')) return;

    window.location.reload();
  });



  (function crossSellColumns() {
    const mobileColumns = 2;

    function renderedColumns(root) {
      const list = root.querySelector('.splide__list');
      const slide = root.querySelector('.splide__slide');
      const slideWidth = slide ? slide.getBoundingClientRect().width : 0;

      if (!list || !slideWidth) return 0;

      return Math.round(list.getBoundingClientRect().width / slideWidth);
    }

    function apply() {
      const widgets = (window.Rebuy && window.Rebuy.widgets) || {};
      const sizes = (window.theme && window.theme.sizes) || { small: 768, large: 1024 };
      const width = window.innerWidth;

      Object.keys(widgets).forEach((key) => {
        const widget = widgets[key];
        const carousel = widget && widget.View && widget.View.carousel;
        const layout = widget && widget.data && widget.data.settings && widget.data.settings.layout;

        if (!carousel || !carousel.root || !layout) return;
        if (!carousel.root.closest('.cart__cross-sell')) return;

        let columns = layout.large.columns;

        if (width < sizes.small) columns = mobileColumns;
        else if (width < sizes.large) columns = layout.medium.columns;

        const rendered = renderedColumns(carousel.root);

        if (rendered && rendered !== columns) carousel.options = { perPage: columns };
      });
    }

    let attempts = 0;
    const poll = setInterval(() => {
      attempts += 1;
      apply();

      if (attempts >= 60) clearInterval(poll);
    }, 250);

    window.addEventListener('resize', apply);
  })();



  /**
  *   Video Mute
  */
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-video-mute').forEach(muteButton => {
      muteButton.addEventListener('click', () => {
        const video = muteButton.parentElement.querySelector('.video__player video');

        if (!video) return;

        video.muted = !video.muted;
        muteButton.classList.toggle('is-unmuted', !video.muted);
        muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    });
  });



  /**
  *   Replace Trademark and Registered Symbols
  */
  document.addEventListener('DOMContentLoaded', () => {
    const els = '.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6, .font-heading, .rte p, .metafield-rich_text_field li, .slide__text, .column-item__text > p > strong, .icons-row-item__text > p, .navtext';
    document.querySelectorAll(els).forEach((element) => {
      const html = element.innerHTML;
      const regex = /™|®/g;
      const newContent = html.replace(regex, '<span class="mark">$&</span>');
      element.innerHTML = newContent;
    });
  });



  /**
  *   Pause background video when lightbox is opened
  */
  document.addEventListener('DOMContentLoaded', () => {
    const playBtn = document.querySelector('[data-video-play]');

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        const wrapper = playBtn.closest('[data-video-wrapper]');
        const bg = wrapper.querySelector('.video-background video');
        const loader = document.querySelector('.pswp--custom-loader');

        if (bg && loader) {
          bg.pause();

          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (!loader.classList.contains('pswp--open')) {
                  bg.play();
                }
              }
            });
          });

          observer.observe(loader, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
      });
    }
  });

  /**
  *   Accordion Tab Switching
  */
  document.addEventListener('DOMContentLoaded', () => {
    const accordionSections = document.querySelectorAll('[data-section-type="accordions"]');

    accordionSections.forEach(section => {
      const tabs = section.querySelectorAll('.accordion__tab');
      const tabContents = section.querySelectorAll('.accordion__tab-content');

      if (tabs.length === 0) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const targetTab = tab.getAttribute('data-tab');
          const targetContent = section.querySelector(`[data-tab-content="${targetTab}"]`);

          tabs.forEach(t => t.classList.remove('accordion__tab--active'));
          tab.classList.add('accordion__tab--active');

          tabContents.forEach(content => {
            content.classList.add('accordion__tab-content--hidden');
          });

          if (targetContent) {
            targetContent.classList.remove('accordion__tab-content--hidden');
          }
        });
      });
    });
  });
})();